<template>
	<WpLink
		:key="buttonLink"
		v-if="buttonLink"
		class="margin-bottom-lg back-link slide-hover"
		:title="buttonTitle"
		:url="buttonLink"
	>
		<span class="icon" v-html="getIcon('arrowParent', '#fff')"></span>
		<span class="txt">{{ buttonTitle }}</span>
	</WpLink>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import WpLink from '@/components/elements/WpLink'

export default {
	name: 'go-up',
	data() {
		return {
			loadedTitle: false,
			isLoadingTitle: false,
			buttonTitle: 'Previous page',
		}
	},
	props: {
		isArchive: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		WpLink,
	},
	computed: {
		...mapGetters(['currentPostType', 'currentPage']),
		home() {
			const WPVUE = window.WPVUE
			return WPVUE.home
		},
		buttonLink() {
			if (this.isArchive) {
				return '/'
			} else if (this.currentPostType === 'post') {
				return WPVUE.pages && WPVUE.pages.posts ? this.home.replace(/\/$/, '') + WPVUE.pages.posts.link : false
			} else if (this.currentPostType === 'events') {
				return WPVUE.pages && WPVUE.pages.events
					? this.home.replace(/\/$/, '') + WPVUE.pages.events.link
					: false
			} else if (this.currentPostType === 'page') {
				if (!this.currentPage.parent) {
					return '/'
				} else {
					let pageLinkSlices = this.currentPage.link.replace(/\/$/, '').split('/')
					let tmp = pageLinkSlices[pageLinkSlices.length - 1]
					return this.currentPage.link.replace(tmp, '')
				}
			} else {
				return '#'
			}
		},
	},
	mounted() {
		this.setButtonTitle()
	},
	methods: {
		//download parent for the page
		...mapActions(['getPost']),
		setButtonTitle() {
			if (this.isArchive) {
				this.buttonTitle = 'Front page'
			} else if (this.currentPostType === 'post') {
				this.buttonTitle = 'All news'
			} else if (this.currentPostType === 'events') {
				this.buttonTitle = 'All events'
			} else if (this.currentPostType === 'page' && !this.currentPage.parent) {
				this.buttonTitle = 'Front page'
			} else {
				if (this.currentPage && this.currentPage.parent && !this.isLoadingTitle && !this.loadedTitle) {
					this.isLoadingTitle = true
					this.getPost({
						type: 'page',
						limit: 1,
						id: this.currentPage.parent,
					}).then((res) => {
						this.isLoadingTitle = false
						this.loadedTitle = true
						if (res && res.data && res.data.posts && res.data.posts[0]) {
							this.buttonTitle = res.data.posts[0].title
						}
					})
				}
				this.buttonTitle = 'Previous page'
			}
		},
	},
}
</script>
